<div *ngIf="!isNewProductSelectorTemplateEnabled; else digitalPlansTransactionalPage">
  <h3 class="m-t-lg">{{ planDetailAEMContent?.selectPlan }}</h3>
  <ng-container *ngFor="let familyModel of planFamilyModel?.planFamilyDetails">
    <p
      class="lead bold m-t-lg"
      *ngIf="familyModel?.planDetails[0].isGrandFathered; else nonGrandFathered"
    >
      {{ planDetailAEMContent?.grandFathered }} {{ familyModel?.familyName }}
    </p>
    <ng-template #nonGrandFathered>
      <p class="lead bold m-t-lg">{{ familyModel?.familyName }}</p>
    </ng-template>
    <p class="m-t-md">{{ familyModel?.familyDescription }}</p>
    <div class="m-t-lg" *ngFor="let plan of familyModel?.planDetails; let planIndex = index">
      <div>
        <div class="row">
          <div class="col-8 col-md-5 col-lg-6">
            <tmo-radio-button
              [aria-label]="
                plan?.planName +
                ' ' +
                planDetailAEMContent?.optionSelectedFor +
                ' ' +
                planFamilyModel?.planFamilyDetails?.familyName
              "
              [values]="plan?.planId"
              [selectedValue]="planOptionSelectorId"
              class="pull-left m-r-md"
              (click)="updateSelectedPlan(plan, plan?.planId)"
              [id]="'tmo-radio-button-default_' + planIndex"
            >
              <p *ngIf="!plan?.isGrandFathered">{{ plan?.planName }}</p>
              <p *ngIf="plan?.isGrandFathered">
                {{ plan?.planName }} ({{ planDetailAEMContent?.grandFathered }})
              </p>
              <!-- <div class="small" *ngIf="isAssisted">
                <p class="small">({{planDetailAEMContent?.offerCode}}: {{plan?.offerCode}})</p>
              </div> -->
              <p class="content small m-t-xs" *ngIf="plan.isSelected">
                {{ plan?.shortDescription }}
              </p>
            </tmo-radio-button>
          </div>
          <div class="col-4 col-md-2 col-lg-2 text-end">
            <p class="lead">{{ plan?.displayPrice | currency: 'USD' : 'symbol-narrow' }}</p>
            <p class="content xsmall">{{ planDetailAEMContent?.perMonth }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-8 col-md-5 col-lg-6">
            <div class="radio-check-spacer">
              <div class="row" *ngIf="plan?.description">
                <div class="col-12 m-t-sm">
                  <tmo-see-more-see-less
                    *ngIf="planFamilyModel?.planDescription && !billingPrepaid && planId"
                    (window:resize)="checkLimit()"
                    [limit]="familySeeMore"
                    [inputText]="plan?.description"
                    [seeMoreText]="planDetailAEMContent?.seeMore"
                    [seeLessText]="planDetailAEMContent?.seeLess"
                  ></tmo-see-more-see-less>
                </div>
              </div>
              <p class="m-t-sm" *ngIf="plan.isSelected">
                <a
                  href="javascript:void(0)"
                  (click)="showSeeMoreModal($event, plan)"
                  id="cta-default-4_{{ planIndex }}"
                  >{{ planDetailAEMContent?.seeMore }}</a
                >
              </p>
              <p class="xsmall m-t-lg" *ngIf="plan.isSelected">
                {{ plan?.planLegalText }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
<ng-template #digitalPlansTransactionalPage>
  <ng-container *ngIf="selectedFamilyId === tMobilePrepaidPlan">
    <h3 *ngIf="!showConnectPlans" class="m-t-xl m-b-xl text-center">{{ planHeader }}</h3>
  </ng-container>
  <ng-container *ngIf="selectedFamilyId !== tMobilePrepaidPlan">
    <tmo-plan-sub-title
      [browsePlanAemContent]="planDetailAEMContent"
      [selectedFamilyId]="selectedFamilyId"
      [planOptions]="planFamilyModel?.planFamilyDetails[0]?.planDetails"
      (onMonthSelection)="handleRadioClickEvent($event)"
      (plansFiltertedByDuration)="getPlansByDuration($event)"
    ></tmo-plan-sub-title>
  </ng-container>
  <ng-container *ngIf="selectedFamilyId === tMobilePrepaidPlan">
    <tmo-plan-sub-title
      [browsePlanAemContent]="planDetailAEMContent"
      [selectedFamilyId]="selectedFamilyId"
      [planOptions]="planFamilyModel?.planFamilyDetails[0]?.planDetails"
      (onMonthSelection)="handleRadioClickEvent($event)"
      (plansFiltertedByDuration)="getPlansByDuration($event)"
      [hidePlansHeader]="true"
      class="xs-display-none"
    ></tmo-plan-sub-title>
  </ng-container>
  <ng-container *ngFor="let familyModel of planFamilyModel?.planFamilyDetails">
    <div id="panelGroup" class="m-t-xxl">
      <div class="panel-group" id="plan-section">
        <div
          *ngFor="let plan of familyModel?.planDetails; let idx = index"
          class="col-xs-12 col-md-12 col-lg-3 plan-block relative"
          [ngClass]="{
            'col-margin-limited-data': showFourTiles,
            'col-margin': !showFourTiles,
            'highlight-border': planOptionSelectorId === plan?.planId,
          }"
          id="block"
        >
          <div
            [ngClass]="planOptionSelectorId === plan?.planId ? 'highlight-plan' : 'plan-checked'"
          >
            <p class="selected-plan">{{ planDetailAEMContent?.youSelectedThisPlan }}</p>
          </div>
          <div class="panel panel-default" id="plan-details">
            <div class="panel-heading">
              <tmo-plan-promotion-header
                [promotionTagIconTemplate]="promotionTagIconTemplate"
                [planPromotions]="planPromotions"
                [planId]="plan?.planId"
              ></tmo-plan-promotion-header>
            </div>
            <div class="panel-body">
              <div class="plan-panel-heading">
                <p class="data-limit m-t-xs">{{ plan?.planName }}</p>
              </div>
              <div class="price-section">
                <p class="plan-price m-t-md">
                  {{ plan?.displayPrice | currency: 'USD' : 'symbol'
                  }}<span>/{{ planDetailAEMContent?.perMonth }}</span>
                </p>
                <ng-container *ngIf="pricingDisclaimer; else defaultDisclainer">
                  <p class="plan-desc m-t-xs">{{ pricingDisclaimer }}</p>
                </ng-container>
                <ng-template #defaultDisclainer>
                  <p class="plan-desc m-t-xs">+ {{ planDetailAEMContent?.taxesAndChanges }}</p>
                </ng-template>
              </div>
              <ng-container *ngIf="planDetailAEMContent && showAutoPayDiscountContent">
                <tmo-autopay-discount
                  [content]="planDetailAEMContent?.autopayDiscountContent"
                  [plan]="plan"
                  (openInfoModal)="toggleAutopayDiscountDetailsModal($event)"/>
              </ng-container>
              <div class="includes-section">
                <p class="features m-t-lg">{{ planDetailAEMContent?.includesLabel }}</p>
                <p class="m-t-lg m-b-md" id="subList1" [innerHTML]="plan?.shortDescription | safeHtml"></p>
              </div>
              <!-- Commented below code as we are not receiving this flag from backend and these fields will not be calculated at UI end -->
              <!-- <p class="plan-desc m-t-xl" *ngIf="showPrepay">{{prepayText}}</p>
              <p class="plan-desc m-t-xl m-b-lg" *ngIf="showPrepay">({{plan?.monthlyPrice?.displayValue*12 | currency:'USD':'symbol'}} {{forMonths}})</p> -->
              <div class="btn-section">
                <a
                  class="plan-detail-link m-t-xl"
                  attr.aria-label="PlanDetails ' Hyperlink'"
                  (click)="showSeeMoreModal($event, plan)"
                  >{{ planDetailAEMContent?.planDetails }} <i class="fa fa-angle-right"></i
                ></a>
                <div
                  *ngIf="isMultilineWarning"
                  [innerHTML]="planDetailAEMContent?.multilineWarning"
                ></div>
                <button
                  *ngIf="planOptionSelectorId !== plan?.planId"
                  class="btn btn-primary m-lg"
                  id="selectPlan"
                  [disabled]="isMultilineWarning"
                  (click)="updateSelectedPlan(plan, plan?.planId)"
                >
                  {{ planDetailAEMContent?.selectPhonePlan }}
                </button>
                <button
                  *ngIf="planOptionSelectorId === plan?.planId"
                  class="btn btn-primary m-lg"
                  id="returnToCart"
                  [disabled]="isMultilineWarning"
                >
                  {{ planDetailAEMContent?.selectedPhonePlan }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <div
    *ngIf="fccLabelLinkText && fccLabelLinkUrl"
    class="text-magenta underline col-12 text-center m-b-lg p-t-md p-b-md"
  >
    <a class="f-w-700 f-s-16" href="{{ fccLabelLinkUrl }}" target="_blank">{{
      fccLabelLinkText
    }}</a>
  </div>
  <ng-container *ngIf="selectedFamilyId === tMobilePrepaidPlan">
    <!-- Adding the tmo-plan-sub-title template here to show only for mobile view -->
    <tmo-plan-sub-title
      [browsePlanAemContent]="planDetailAEMContent"
      [selectedFamilyId]="selectedFamilyId"
      [planOptions]="planFamilyModel?.planFamilyDetails[0]?.planDetails"
      (onMonthSelection)="handleRadioClickEvent($event)"
      (plansFiltertedByDuration)="getPlansByDuration($event)"
      [hidePlansHeader]="true"
      class="sm-upper-display-none"
    ></tmo-plan-sub-title>
  </ng-container>
</ng-template>
<tmo-dynamic-modal [modal]="autopayDiscountDetailsModal">
  <ng-container header>
    <div class="modal-logo-close">
      <a
        tabindex="0"
        [attr.aria-label]="planDetailAEMContent?.clickToClose"
        href="javascript:void(0)"
        class="close-x pull-right"
        (click)="toggleAutopayDiscountDetailsModal(false)"
        id="cta-click-to-close-3_{{ autopayDiscountDetailsModal.modalName }}"
      >
        <i class="fa fa-times-circle"></i>
      </a>
    </div>
    <div class="row">
      <div class="col-12 m-t-md">
        <h3>{{ autopayDiscountDetailsModal?.headerText }}</h3>
      </div>
    </div>
  </ng-container>
  <div class="digital m-b-xl">
    <p
      class="small"
      id="pdialog-bodytext"
      [innerHtml]="autopayDiscountDetailsModal?.bodyText"
    ></p>
  </div>
</tmo-dynamic-modal>
<tmo-dynamic-modal
  [modal]="modal"
  [styleClass]="isNewProductSelectorTemplateEnabled ? 'digital' : ''"
>
  <ng-container header>
    <div class="modal-logo-close">
      <a
        tabindex="0"
        [attr.aria-label]="planDetailAEMContent?.clickToClose"
        href="javascript:void(0)"
        class="close-x pull-right"
        (click)="closeModal()"
        id="cta-click-to-close-3_{{ selectedPlan?.planId }}"
      >
        <i *ngIf="!isNewProductSelectorTemplateEnabled" class="fa fa-times"></i>
        <i *ngIf="isNewProductSelectorTemplateEnabled" class="fa fa-times-circle"></i>
      </a>
    </div>
    <div [class]="isNewProductSelectorTemplateEnabled ? 'row digital' : 'row'">
      <div [class]="!isNewProductSelectorTemplateEnabled ? 'col-8' : 'col-12 m-t-md'">
        <h3>{{ selectedPlan?.planName }}</h3>
      </div>
      <div *ngIf="!isNewProductSelectorTemplateEnabled" class="col-4 p-t-md m-t-sm text-end">
        <p class="lead">{{ selectedPlan?.displayPrice | currency: 'USD' : 'symbol-narrow' }}</p>
        <p class="xsmall">{{ planDetailAEMContent?.perMonth }}</p>
      </div>
      <!-- <div class="col-12 m-t-sm" *ngIf="isAssisted">
        <p class="small">({{planDetailAEMContent?.offerCode}}: {{selectedPlan?.offerCode}})</p>
      </div> -->
    </div>
  </ng-container>
  <div [class]="!isNewProductSelectorTemplateEnabled ? '' : 'digital m-b-xl'">
    <p
      [class]="!isNewProductSelectorTemplateEnabled ? 'lead bold m-t-sm' : 'lead bold p-b-sm'"
      *ngIf="planDetailAEMContent?.planDescription"
    >
      {{ planDetailAEMContent?.planDescription }}
    </p>
    <p
      [class]="!isNewProductSelectorTemplateEnabled ? 'small m-t-sm' : 'p-b-sm'"
      *ngIf="selectedPlan?.planLongDescription"
    >
      {{ selectedPlan?.planLongDescription }}
    </p>
    <p
      [class]="!isNewProductSelectorTemplateEnabled ? 'small m-t-md' : 'p-b-sm'"
      *ngIf="selectedPlan?.planAlternateDesription"
    >
      {{ selectedPlan?.planAlternateDesription }}
    </p>
  </div>
  <ng-container footer> </ng-container>
</tmo-dynamic-modal>
